/**
 * openConversationLink — ouvrir l'adresse d'un lien touché dans un message (`conversationLinks`), la
 * même pour la messagerie et le chat du live, du geste de « Une question ? » (`openAppLink`) : sur le
 * web, un e-mail ou un numéro passe la main sans laisser d'onglet vide. Un lien que le système ne
 * sait pas ouvrir se dit dans Bugsnag — son genre seul, jamais son adresse.
 */
import { createTelemetry } from "../../../../../../engine/shared/telemetry"
import { openAppLink } from "../../../hooks/openSupportEmail"
import { type UIMessageLink } from "../../../types/studentConversation"

const linkTelemetry = createTelemetry("messaging-student.links", { role: "student" })

export function openConversationLink(href: string, kind: UIMessageLink["kind"]): void {
    openAppLink(href).catch(() => {
        // Pas la cause : le message de React Native cite l'adresse (« Could not open URL 'mailto:…' »),
        // qui partirait à Bugsnag — un e-mail, un numéro de téléphone.
        linkTelemetry.error("open-link", new Error("open_link_failed"), { kind })
    })
}
